import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { IoIosArrowBack } from "react-icons/io";

import Button from "../../../../global/button";
import LocationSearch from "../location-search";

import "./styles.css";
import { filterItems } from "../../../../global/filter/initialStates";
import PropertyFilterModal from "../../../../property-listing-cards/property-filter-modal";
import { destinationFilterItems } from "../../../../global/filter/destinationInitialStates";

const MapHeader = ({ searchCriteria, params, paramFilters, summary, closeGoogleMapModal }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [isFocused, setIsFocused] = useState(false);

  const handleBack = () => {
    setIsFocused(false);
  };

  return (
    <div className="search-close-header">
      <div className="search-bar-close-button">
        <div className="places-search-bar">
          <LocationSearch
            suggestions={suggestions}
            params={params}
            searchCriteria={searchCriteria}
            setSuggestions={setSuggestions}
            isFocused={isFocused}
            setIsFocused={setIsFocused}
          />
        </div>
        <Button onClick={closeGoogleMapModal} className="close-map-button" variant="secondary" size="small">
          <IoClose />
        </Button>

        {isFocused ? (
          <Button onClick={handleBack} className="close-map-button-mobile" variant="secondary" size="small">
            <IoIosArrowBack color="#006ce4" />
          </Button>
        ) : (
          <Button onClick={closeGoogleMapModal} className="close-map-button-mobile" variant="secondary" size="small">
            <IoClose />
          </Button>
        )}
      </div>
      {isFocused ? (
        ""
      ) : (
        <div className="mobile-map-filters">
          <PropertyFilterModal
            params={params}
            filters={destinationFilterItems}
            paramFilters={paramFilters}
            mapMobileFilter="map-mobile-filter"
            isDestinations={true}
          />
        </div>
      )}
    </div>
  );
};

export default MapHeader;
